import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[integerOnly][integerOnlyMinValue]'
})
export class IntegerOnlyDirective {

  @Input('integerOnlyMinValue') minValue: number | null = null;
  @Input('integerOnlyMaxValue') maxValue: number | null = null;

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInputChange(event: Event) {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    const initialValue = inputElement.value;

    // Remove non-numeric characters
    const newValue = initialValue.replace(/[^0-9]/g, '');

    // Only update the value if it has changed
    if (newValue !== initialValue) {
      inputElement.value = newValue;
    } 
    // // Manually dispatch the input event to ensure Angular detects the change
    // const nativeInputEvent = new Event('change', { bubbles: true });
    // inputElement.dispatchEvent(nativeInputEvent);
  }

  @HostListener('blur', ['$event']) onInputBlur(event: Event) {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    let value = Number(inputElement.value);

    // If the input is empty, reset to minValue (if defined)
    if (inputElement.value === '') {
      inputElement.value = this.minValue !== null ? String(this.minValue) : '';
      return;
    }

    // Enforce minValue
    if (this.minValue !== null && value < this.minValue) {
      inputElement.value = String(this.minValue);
      return;
    }

    // Enforce maxValue
    if (this.maxValue !== null && value > this.maxValue) {
      inputElement.value = String(this.maxValue);
      return;
    }
  }

 
}